export default __webpack_public_path__ + "static/part1-sketch-753f312a724fb4352f468efee314ba38.jpg";